export default __webpack_public_path__ + "static/blog-fcd51e7fd7b4c5213cf29890187a6e3b.png";